(() => {
  const initGiftSetStickyAtc = (sectionEl) => {
    if (!sectionEl) return;

    const stickyBar = sectionEl.querySelector('[data-sticky-atc]');
    const stickyButton = sectionEl.querySelector('[data-sticky-atc-btn]');
    const mainSubmit = sectionEl.querySelector('#product-form-gift-set .product-form__submit');
    if (!stickyBar || !stickyButton || !mainSubmit) return;

    stickyBar.hidden = false;

    stickyButton.addEventListener('click', () => {
      if (!mainSubmit.disabled) mainSubmit.click();
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          stickyBar.classList.toggle('sticky-atc--visible', !entry.isIntersecting);
        });
      },
      { threshold: 0, rootMargin: '0px' }
    );

    observer.observe(mainSubmit);
  };

  const initGiftSetReadMore = (sectionEl) => {
    if (!sectionEl) return;

    const description = sectionEl.querySelector('.product__description');
    const toggleBtn = sectionEl.querySelector('[data-gift-set-read-more]');
    if (!description || !toggleBtn) return;

    const updateButtonVisibility = () => {
      if (description.classList.contains('combined-product__description--expanded')) return;

      description.classList.add('combined-product__description--truncated');
      const overflows = description.scrollHeight > description.clientHeight + 2;

      toggleBtn.classList.toggle('combined-product__read-more-btn--visible', overflows);
      if (!overflows) {
        description.classList.remove('combined-product__description--truncated');
        toggleBtn.textContent = 'Read more';
      }
    };

    toggleBtn.addEventListener('click', () => {
      const expanded = description.classList.contains('combined-product__description--expanded');
      if (expanded) {
        description.classList.remove('combined-product__description--expanded');
        description.classList.add('combined-product__description--truncated');
        toggleBtn.textContent = 'Read more';
      } else {
        description.classList.add('combined-product__description--expanded');
        toggleBtn.textContent = 'Read less';
      }
    });

    requestAnimationFrame(updateButtonVisibility);
    window.addEventListener('resize', updateButtonVisibility);
  };

  const run = () => {
    document
      .querySelectorAll('.gift-set-main-product')
      .forEach((section) => {
        const scopedRoot = section.closest('.shopify-section') || section;
        initGiftSetStickyAtc(scopedRoot);
        initGiftSetReadMore(scopedRoot);
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
